import { __decorate } from 'tslib';
import { InjectionToken, Input, Directive, forwardRef, NgModule, ChangeDetectorRef } from '@angular/core';
import { TuiController, watch, TuiDestroyService } from '@taiga-ui/cdk';
import { merge, NEVER } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
class TuiTextfieldController {
    constructor(change$, autocompleteDirective, cleanerDirective, customContentDirective, exampleTextDirective, inputModeDirective, labelOutsideDirective, maxLengthDirective, sizeDirective, typeDirective) {
        this.change$ = change$;
        this.autocompleteDirective = autocompleteDirective;
        this.cleanerDirective = cleanerDirective;
        this.customContentDirective = customContentDirective;
        this.exampleTextDirective = exampleTextDirective;
        this.inputModeDirective = inputModeDirective;
        this.labelOutsideDirective = labelOutsideDirective;
        this.maxLengthDirective = maxLengthDirective;
        this.sizeDirective = sizeDirective;
        this.typeDirective = typeDirective;
    }
    get autocomplete() {
        return this.autocompleteDirective.autocomplete;
    }
    get cleaner() {
        return this.cleanerDirective.cleaner;
    }
    get customContent() {
        return this.customContentDirective.customContent || '';
    }
    get exampleText() {
        return this.exampleTextDirective.exampleText;
    }
    get inputMode() {
        return this.inputModeDirective.inputMode;
    }
    get labelOutside() {
        return this.labelOutsideDirective.labelOutside;
    }
    get maxLength() {
        return this.maxLengthDirective.maxLength;
    }
    get size() {
        return this.sizeDirective.size;
    }
    get type() {
        return this.typeDirective.type;
    }
}

var TuiTextfieldAutocompleteDirective_1;
const TUI_TEXTFIELD_AUTOCOMPLETE = new InjectionToken('tuiTextfieldAutocomplete', {
    factory: autocompleteDirectiveFactory,
});
let TuiTextfieldAutocompleteDirective = TuiTextfieldAutocompleteDirective_1 = class TuiTextfieldAutocompleteDirective extends TuiController {
    constructor() {
        super(...arguments);
        this.autocomplete = '';
    }
};
TuiTextfieldAutocompleteDirective.ɵfac = /*@__PURE__*/ function () { let ɵTuiTextfieldAutocompleteDirective_BaseFactory; return function TuiTextfieldAutocompleteDirective_Factory(t) { return (ɵTuiTextfieldAutocompleteDirective_BaseFactory || (ɵTuiTextfieldAutocompleteDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiTextfieldAutocompleteDirective)))(t || TuiTextfieldAutocompleteDirective); }; }();
TuiTextfieldAutocompleteDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiTextfieldAutocompleteDirective, selectors: [["", "tuiTextfieldAutocomplete", ""]], inputs: { autocomplete: ["tuiTextfieldAutocomplete", "autocomplete"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_TEXTFIELD_AUTOCOMPLETE,
                useExisting: forwardRef(() => TuiTextfieldAutocompleteDirective_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input('tuiTextfieldAutocomplete')
], TuiTextfieldAutocompleteDirective.prototype, "autocomplete", void 0);
function autocompleteDirectiveFactory() {
    return new TuiTextfieldAutocompleteDirective();
}

var TuiTextfieldCleanerDirective_1;
const TUI_TEXTFIELD_CLEANER = new InjectionToken('tuiTextfieldCleaner', {
    factory: cleanerDirectiveFactory,
});
let TuiTextfieldCleanerDirective = TuiTextfieldCleanerDirective_1 = class TuiTextfieldCleanerDirective extends TuiController {
    constructor() {
        super(...arguments);
        this.cleaner = false;
    }
};
TuiTextfieldCleanerDirective.ɵfac = /*@__PURE__*/ function () { let ɵTuiTextfieldCleanerDirective_BaseFactory; return function TuiTextfieldCleanerDirective_Factory(t) { return (ɵTuiTextfieldCleanerDirective_BaseFactory || (ɵTuiTextfieldCleanerDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiTextfieldCleanerDirective)))(t || TuiTextfieldCleanerDirective); }; }();
TuiTextfieldCleanerDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiTextfieldCleanerDirective, selectors: [["", "tuiTextfieldCleaner", ""]], inputs: { cleaner: ["tuiTextfieldCleaner", "cleaner"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_TEXTFIELD_CLEANER,
                useExisting: forwardRef(() => TuiTextfieldCleanerDirective_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input('tuiTextfieldCleaner')
], TuiTextfieldCleanerDirective.prototype, "cleaner", void 0);
function cleanerDirectiveFactory() {
    return new TuiTextfieldCleanerDirective();
}

var TuiTextfieldCustomContentDirective_1;
const TUI_TEXTFIELD_CUSTOM_CONTENT = new InjectionToken('tuiTextfieldCustomContent', {
    factory: customContentDirectiveFactory,
});
let TuiTextfieldCustomContentDirective = TuiTextfieldCustomContentDirective_1 = class TuiTextfieldCustomContentDirective extends TuiController {
    constructor() {
        super(...arguments);
        // TODO: Remove null in 3.0
        this.customContent = null;
    }
};
TuiTextfieldCustomContentDirective.ɵfac = /*@__PURE__*/ function () { let ɵTuiTextfieldCustomContentDirective_BaseFactory; return function TuiTextfieldCustomContentDirective_Factory(t) { return (ɵTuiTextfieldCustomContentDirective_BaseFactory || (ɵTuiTextfieldCustomContentDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiTextfieldCustomContentDirective)))(t || TuiTextfieldCustomContentDirective); }; }();
TuiTextfieldCustomContentDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiTextfieldCustomContentDirective, selectors: [["", "tuiTextfieldCustomContent", ""]], inputs: { customContent: ["tuiTextfieldCustomContent", "customContent"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_TEXTFIELD_CUSTOM_CONTENT,
                useExisting: forwardRef(() => TuiTextfieldCustomContentDirective_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input('tuiTextfieldCustomContent')
], TuiTextfieldCustomContentDirective.prototype, "customContent", void 0);
function customContentDirectiveFactory() {
    return new TuiTextfieldCustomContentDirective();
}

var TuiTextfieldExampleTextDirective_1;
const TUI_TEXTFIELD_EXAMPLE_TEXT = new InjectionToken('tuiTextfieldExampleText', {
    factory: exampleTextDirectiveFactory,
});
let TuiTextfieldExampleTextDirective = TuiTextfieldExampleTextDirective_1 = class TuiTextfieldExampleTextDirective extends TuiController {
    constructor() {
        super(...arguments);
        this.exampleText = '';
    }
};
TuiTextfieldExampleTextDirective.ɵfac = /*@__PURE__*/ function () { let ɵTuiTextfieldExampleTextDirective_BaseFactory; return function TuiTextfieldExampleTextDirective_Factory(t) { return (ɵTuiTextfieldExampleTextDirective_BaseFactory || (ɵTuiTextfieldExampleTextDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiTextfieldExampleTextDirective)))(t || TuiTextfieldExampleTextDirective); }; }();
TuiTextfieldExampleTextDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiTextfieldExampleTextDirective, selectors: [["", "tuiTextfieldExampleText", ""]], inputs: { exampleText: ["tuiTextfieldExampleText", "exampleText"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_TEXTFIELD_EXAMPLE_TEXT,
                useExisting: forwardRef(() => TuiTextfieldExampleTextDirective_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input('tuiTextfieldExampleText')
], TuiTextfieldExampleTextDirective.prototype, "exampleText", void 0);
function exampleTextDirectiveFactory() {
    return new TuiTextfieldExampleTextDirective();
}

var TuiTextfieldInputModeDirective_1;
const TUI_TEXTFIELD_INPUT_MODE = new InjectionToken('tuiTextfieldInputMode', {
    factory: inputModeDirectiveFactory,
});
let TuiTextfieldInputModeDirective = TuiTextfieldInputModeDirective_1 = class TuiTextfieldInputModeDirective extends TuiController {
    constructor() {
        super(...arguments);
        this.inputMode = 'text';
    }
};
TuiTextfieldInputModeDirective.ɵfac = /*@__PURE__*/ function () { let ɵTuiTextfieldInputModeDirective_BaseFactory; return function TuiTextfieldInputModeDirective_Factory(t) { return (ɵTuiTextfieldInputModeDirective_BaseFactory || (ɵTuiTextfieldInputModeDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiTextfieldInputModeDirective)))(t || TuiTextfieldInputModeDirective); }; }();
TuiTextfieldInputModeDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiTextfieldInputModeDirective, selectors: [["", "tuiTextfieldInputMode", ""]], inputs: { inputMode: ["tuiTextfieldInputMode", "inputMode"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_TEXTFIELD_INPUT_MODE,
                useExisting: forwardRef(() => TuiTextfieldInputModeDirective_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input('tuiTextfieldInputMode')
], TuiTextfieldInputModeDirective.prototype, "inputMode", void 0);
function inputModeDirectiveFactory() {
    return new TuiTextfieldInputModeDirective();
}

var TuiTextfieldLabelOutsideDirective_1;
const TUI_TEXTFIELD_LABEL_OUTSIDE = new InjectionToken('tuiTextfieldLabelOutside', {
    factory: labelOutsideDirectiveFactory,
});
let TuiTextfieldLabelOutsideDirective = TuiTextfieldLabelOutsideDirective_1 = class TuiTextfieldLabelOutsideDirective extends TuiController {
    constructor() {
        super(...arguments);
        this.labelOutside = false;
    }
};
TuiTextfieldLabelOutsideDirective.ɵfac = /*@__PURE__*/ function () { let ɵTuiTextfieldLabelOutsideDirective_BaseFactory; return function TuiTextfieldLabelOutsideDirective_Factory(t) { return (ɵTuiTextfieldLabelOutsideDirective_BaseFactory || (ɵTuiTextfieldLabelOutsideDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiTextfieldLabelOutsideDirective)))(t || TuiTextfieldLabelOutsideDirective); }; }();
TuiTextfieldLabelOutsideDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiTextfieldLabelOutsideDirective, selectors: [["", "tuiTextfieldLabelOutside", ""]], inputs: { labelOutside: ["tuiTextfieldLabelOutside", "labelOutside"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_TEXTFIELD_LABEL_OUTSIDE,
                useExisting: forwardRef(() => TuiTextfieldLabelOutsideDirective_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input('tuiTextfieldLabelOutside')
], TuiTextfieldLabelOutsideDirective.prototype, "labelOutside", void 0);
function labelOutsideDirectiveFactory() {
    return new TuiTextfieldLabelOutsideDirective();
}

var TuiTextfieldMaxLengthDirective_1;
const TUI_TEXTFIELD_MAX_LENGTH = new InjectionToken('tuiTextfieldMaxLength', {
    factory: maxLengthDirectiveFactory,
});
let TuiTextfieldMaxLengthDirective = TuiTextfieldMaxLengthDirective_1 = class TuiTextfieldMaxLengthDirective extends TuiController {
    constructor() {
        super(...arguments);
        this.maxLength = null;
    }
};
TuiTextfieldMaxLengthDirective.ɵfac = /*@__PURE__*/ function () { let ɵTuiTextfieldMaxLengthDirective_BaseFactory; return function TuiTextfieldMaxLengthDirective_Factory(t) { return (ɵTuiTextfieldMaxLengthDirective_BaseFactory || (ɵTuiTextfieldMaxLengthDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiTextfieldMaxLengthDirective)))(t || TuiTextfieldMaxLengthDirective); }; }();
TuiTextfieldMaxLengthDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiTextfieldMaxLengthDirective, selectors: [["", "tuiTextfieldMaxLength", ""]], inputs: { maxLength: ["tuiTextfieldMaxLength", "maxLength"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_TEXTFIELD_MAX_LENGTH,
                useExisting: forwardRef(() => TuiTextfieldMaxLengthDirective_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input('tuiTextfieldMaxLength')
], TuiTextfieldMaxLengthDirective.prototype, "maxLength", void 0);
function maxLengthDirectiveFactory() {
    return new TuiTextfieldMaxLengthDirective();
}

var TuiTextfieldSizeDirective_1;
const TUI_TEXTFIELD_SIZE = new InjectionToken('tuiTextfieldSize', {
    factory: sizeDirectiveFactory,
});
let TuiTextfieldSizeDirective = TuiTextfieldSizeDirective_1 = class TuiTextfieldSizeDirective extends TuiController {
    constructor() {
        super(...arguments);
        this.size = 'l';
    }
};
TuiTextfieldSizeDirective.ɵfac = /*@__PURE__*/ function () { let ɵTuiTextfieldSizeDirective_BaseFactory; return function TuiTextfieldSizeDirective_Factory(t) { return (ɵTuiTextfieldSizeDirective_BaseFactory || (ɵTuiTextfieldSizeDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiTextfieldSizeDirective)))(t || TuiTextfieldSizeDirective); }; }();
TuiTextfieldSizeDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiTextfieldSizeDirective, selectors: [["", "tuiTextfieldSize", ""]], inputs: { size: ["tuiTextfieldSize", "size"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_TEXTFIELD_SIZE,
                useExisting: forwardRef(() => TuiTextfieldSizeDirective_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input('tuiTextfieldSize')
], TuiTextfieldSizeDirective.prototype, "size", void 0);
function sizeDirectiveFactory() {
    return new TuiTextfieldSizeDirective();
}

var TuiTextfieldTypeDirective_1;
const TUI_TEXTFIELD_TYPE = new InjectionToken('tuiTextfieldType', {
    factory: typeDirectiveFactory,
});
let TuiTextfieldTypeDirective = TuiTextfieldTypeDirective_1 = class TuiTextfieldTypeDirective extends TuiController {
    constructor() {
        super(...arguments);
        this.type = 'text';
    }
};
TuiTextfieldTypeDirective.ɵfac = /*@__PURE__*/ function () { let ɵTuiTextfieldTypeDirective_BaseFactory; return function TuiTextfieldTypeDirective_Factory(t) { return (ɵTuiTextfieldTypeDirective_BaseFactory || (ɵTuiTextfieldTypeDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiTextfieldTypeDirective)))(t || TuiTextfieldTypeDirective); }; }();
TuiTextfieldTypeDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiTextfieldTypeDirective, selectors: [["", "tuiTextfieldType", ""]], inputs: { type: ["tuiTextfieldType", "type"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_TEXTFIELD_TYPE,
                useExisting: forwardRef(() => TuiTextfieldTypeDirective_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
__decorate([
    Input('tuiTextfieldType')
], TuiTextfieldTypeDirective.prototype, "type", void 0);
function typeDirectiveFactory() {
    return new TuiTextfieldTypeDirective();
}

let TuiTextfieldControllerModule = class TuiTextfieldControllerModule {
};
TuiTextfieldControllerModule.ɵfac = function TuiTextfieldControllerModule_Factory(t) { return new (t || TuiTextfieldControllerModule)(); };
TuiTextfieldControllerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiTextfieldControllerModule });
TuiTextfieldControllerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiTextfieldAutocompleteDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiTextfieldAutocomplete]',
                providers: [
                    {
                        provide: TUI_TEXTFIELD_AUTOCOMPLETE,
                        useExisting: forwardRef(() => TuiTextfieldAutocompleteDirective_1)
                    },
                ]
            }]
    }], null, { autocomplete: [{
            type: Input,
            args: ['tuiTextfieldAutocomplete']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiTextfieldCleanerDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiTextfieldCleaner]',
                providers: [
                    {
                        provide: TUI_TEXTFIELD_CLEANER,
                        useExisting: forwardRef(() => TuiTextfieldCleanerDirective_1)
                    },
                ]
            }]
    }], null, { cleaner: [{
            type: Input,
            args: ['tuiTextfieldCleaner']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiTextfieldCustomContentDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiTextfieldCustomContent]',
                providers: [
                    {
                        provide: TUI_TEXTFIELD_CUSTOM_CONTENT,
                        useExisting: forwardRef(() => TuiTextfieldCustomContentDirective_1)
                    },
                ]
            }]
    }], null, { customContent: [{
            type: Input,
            args: ['tuiTextfieldCustomContent']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiTextfieldExampleTextDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiTextfieldExampleText]',
                providers: [
                    {
                        provide: TUI_TEXTFIELD_EXAMPLE_TEXT,
                        useExisting: forwardRef(() => TuiTextfieldExampleTextDirective_1)
                    },
                ]
            }]
    }], null, { exampleText: [{
            type: Input,
            args: ['tuiTextfieldExampleText']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiTextfieldInputModeDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiTextfieldInputMode]',
                providers: [
                    {
                        provide: TUI_TEXTFIELD_INPUT_MODE,
                        useExisting: forwardRef(() => TuiTextfieldInputModeDirective_1)
                    },
                ]
            }]
    }], null, { inputMode: [{
            type: Input,
            args: ['tuiTextfieldInputMode']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiTextfieldLabelOutsideDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiTextfieldLabelOutside]',
                providers: [
                    {
                        provide: TUI_TEXTFIELD_LABEL_OUTSIDE,
                        useExisting: forwardRef(() => TuiTextfieldLabelOutsideDirective_1)
                    },
                ]
            }]
    }], null, { labelOutside: [{
            type: Input,
            args: ['tuiTextfieldLabelOutside']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiTextfieldMaxLengthDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiTextfieldMaxLength]',
                providers: [
                    {
                        provide: TUI_TEXTFIELD_MAX_LENGTH,
                        useExisting: forwardRef(() => TuiTextfieldMaxLengthDirective_1)
                    },
                ]
            }]
    }], null, { maxLength: [{
            type: Input,
            args: ['tuiTextfieldMaxLength']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiTextfieldSizeDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiTextfieldSize]',
                providers: [
                    {
                        provide: TUI_TEXTFIELD_SIZE,
                        useExisting: forwardRef(() => TuiTextfieldSizeDirective_1)
                    },
                ]
            }]
    }], null, { size: [{
            type: Input,
            args: ['tuiTextfieldSize']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiTextfieldTypeDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiTextfieldType]',
                providers: [
                    {
                        provide: TUI_TEXTFIELD_TYPE,
                        useExisting: forwardRef(() => TuiTextfieldTypeDirective_1)
                    },
                ]
            }]
    }], null, { type: [{
            type: Input,
            args: ['tuiTextfieldType']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiTextfieldControllerModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TuiTextfieldAutocompleteDirective,
                    TuiTextfieldCleanerDirective,
                    TuiTextfieldCustomContentDirective,
                    TuiTextfieldExampleTextDirective,
                    TuiTextfieldInputModeDirective,
                    TuiTextfieldLabelOutsideDirective,
                    TuiTextfieldMaxLengthDirective,
                    TuiTextfieldSizeDirective,
                    TuiTextfieldTypeDirective,
                ],
                exports: [
                    TuiTextfieldAutocompleteDirective,
                    TuiTextfieldCleanerDirective,
                    TuiTextfieldCustomContentDirective,
                    TuiTextfieldExampleTextDirective,
                    TuiTextfieldInputModeDirective,
                    TuiTextfieldLabelOutsideDirective,
                    TuiTextfieldMaxLengthDirective,
                    TuiTextfieldSizeDirective,
                    TuiTextfieldTypeDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiTextfieldControllerModule, { declarations: [TuiTextfieldAutocompleteDirective, TuiTextfieldCleanerDirective, TuiTextfieldCustomContentDirective, TuiTextfieldExampleTextDirective, TuiTextfieldInputModeDirective, TuiTextfieldLabelOutsideDirective, TuiTextfieldMaxLengthDirective, TuiTextfieldSizeDirective, TuiTextfieldTypeDirective], exports: [TuiTextfieldAutocompleteDirective, TuiTextfieldCleanerDirective, TuiTextfieldCustomContentDirective, TuiTextfieldExampleTextDirective, TuiTextfieldInputModeDirective, TuiTextfieldLabelOutsideDirective, TuiTextfieldMaxLengthDirective, TuiTextfieldSizeDirective, TuiTextfieldTypeDirective] }); })();

const TUI_TEXTFIELD_WATCHED_CONTROLLER = new InjectionToken('watched textfield controller');
function textfieldWatchedControllerFactory(changeDetectorRef, destroy$, ...controllers) {
    const change$ = merge(...controllers.map(({ change$ }) => change$ || NEVER)).pipe(watch(changeDetectorRef), takeUntil(destroy$));
    change$.subscribe();
    return new TuiTextfieldController(change$, ...controllers);
}
const TEXTFIELD_CONTROLLER_PROVIDER = [
    TuiDestroyService,
    {
        provide: TUI_TEXTFIELD_WATCHED_CONTROLLER,
        deps: [
            ChangeDetectorRef,
            TuiDestroyService,
            TUI_TEXTFIELD_AUTOCOMPLETE,
            TUI_TEXTFIELD_CLEANER,
            TUI_TEXTFIELD_CUSTOM_CONTENT,
            TUI_TEXTFIELD_EXAMPLE_TEXT,
            TUI_TEXTFIELD_INPUT_MODE,
            TUI_TEXTFIELD_LABEL_OUTSIDE,
            TUI_TEXTFIELD_MAX_LENGTH,
            TUI_TEXTFIELD_SIZE,
            TUI_TEXTFIELD_TYPE,
        ],
        useFactory: textfieldWatchedControllerFactory,
    },
];

/**
 * Generated bundle index. Do not edit.
 */

export { TEXTFIELD_CONTROLLER_PROVIDER, TUI_TEXTFIELD_AUTOCOMPLETE, TUI_TEXTFIELD_CLEANER, TUI_TEXTFIELD_CUSTOM_CONTENT, TUI_TEXTFIELD_EXAMPLE_TEXT, TUI_TEXTFIELD_INPUT_MODE, TUI_TEXTFIELD_LABEL_OUTSIDE, TUI_TEXTFIELD_MAX_LENGTH, TUI_TEXTFIELD_SIZE, TUI_TEXTFIELD_TYPE, TUI_TEXTFIELD_WATCHED_CONTROLLER, TuiTextfieldAutocompleteDirective, TuiTextfieldCleanerDirective, TuiTextfieldController, TuiTextfieldControllerModule, TuiTextfieldCustomContentDirective, TuiTextfieldExampleTextDirective, TuiTextfieldInputModeDirective, TuiTextfieldLabelOutsideDirective, TuiTextfieldMaxLengthDirective, TuiTextfieldSizeDirective, TuiTextfieldTypeDirective, autocompleteDirectiveFactory, cleanerDirectiveFactory, customContentDirectiveFactory, exampleTextDirectiveFactory, inputModeDirectiveFactory, labelOutsideDirectiveFactory, maxLengthDirectiveFactory, sizeDirectiveFactory, textfieldWatchedControllerFactory, typeDirectiveFactory };

